import { render, staticRenderFns } from "./IconBilling.vue?vue&type=template&id=c2505d1e&"
import script from "./IconBilling.vue?vue&type=script&lang=ts&"
export * from "./IconBilling.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports